import { Box, Button, Text, config, toRem } from 'folds';
import { Code, EnvelopeSimple, menuIcon } from '$components/icons/phosphor';
import { Page, PageHero, PageHeroSection } from '$components/page';
import { ThemeKind, useSystemThemeKind } from '$hooks/useTheme';
import { versionLabel } from '$utils/platform';
import UTLogoBlack from '$public/res/ut/UT_Logo_2400_Sta_Black_EN.png';
import UTLogoWhite from '$public/res/ut/UT_Logo_2400_Sta_White_EN.png';

export function WelcomePage() {
  const themeKind = useSystemThemeKind();

  return (
    <Page>
      <Box
        grow="Yes"
        style={{ padding: config.space.S400, paddingBottom: config.space.S700 }}
        alignItems="Center"
        justifyContent="Center"
      >
        <PageHeroSection>
          <PageHero
            icon={
              <img
                height="70"
                src={themeKind === ThemeKind.Light ? UTLogoBlack : UTLogoWhite}
                alt="UT Logo"
              />
            }
            title="Welcome to the EEMCS matrix client"
            subTitle={
              <span>
                Using Sable{' '}
                <a
                  href="https://github.com/SableClient/Sable"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  {versionLabel()}
                </a>
              </span>
            }
          >
            <Box justifyContent="Center">
              <Box grow="Yes" style={{ maxWidth: toRem(300) }} direction="Column" gap="300">
                <Button
                  as="a"
                  href="https://gitlab.utwente.nl/matrix-project/webchat"
                  target="_blank"
                  rel="noreferrer noopener"
                  before={menuIcon(Code)}
                >
                  <Text as="span" size="B400" truncate>
                    Source Code
                  </Text>
                </Button>
                <Button
                  as="a"
                  href="https://chat.eemcs.utwente.nl/home/%23help%3Amatrix.eemcs.utwente.nl"
                  fill="Soft"
                  before={menuIcon(EnvelopeSimple)}
                >
                  <Text as="span" size="B400" truncate>
                    Help
                  </Text>
                </Button>
              </Box>
            </Box>
          </PageHero>
        </PageHeroSection>
      </Box>
    </Page>
  );
}
